import { __rest } from "tslib";
import * as React from 'react';
import { Button, ButtonVariant } from '../Button';
import { AlertContext } from './AlertContext';
import AngleRightIcon from '@patternfly/react-icons/dist/esm/icons/angle-right-icon';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Alert/alert';
export var AlertToggleExpandButton = function AlertToggleExpandButton(_a) {
  var ariaLabel = _a['aria-label'],
      variantLabel = _a.variantLabel,
      onToggleExpand = _a.onToggleExpand,
      isExpanded = _a.isExpanded,
      props = __rest(_a, ['aria-label', "variantLabel", "onToggleExpand", "isExpanded"]);

  var _React$useContext = React.useContext(AlertContext),
      title = _React$useContext.title,
      alertVariantLabel = _React$useContext.variantLabel;

  return React.createElement(Button, Object.assign({
    variant: ButtonVariant.plain,
    onClick: onToggleExpand,
    "aria-expanded": isExpanded,
    "aria-label": ariaLabel === '' ? "Toggle ".concat(variantLabel || alertVariantLabel, " alert: ").concat(title) : ariaLabel
  }, props), React.createElement("span", {
    className: css(styles.alertToggleIcon)
  }, React.createElement(AngleRightIcon, {
    "aria-hidden": "true"
  })));
};
AlertToggleExpandButton.displayName = 'AlertToggleExpandButton';